module.exports = __webpack_public_path__ + "static/media/czerwony_stres.16b3558d.png";